/* Datos de puntos de venta fisicos de Jousfit.
 * Editar SOLO este archivo para agregar / quitar puntos.  ->  poco a poco mas estados.
 *
 * Campos por punto:
 *   id        (string, unico)     ej. "gdl-centro"
 *   tipo      (string, opcional)  "tienda" (default si falta) | "distribuidora"
 *   precision (string, opcional)  "exacta" (default) | "zona"   <- ver nota de privacidad
 *   nombre    (string)            nombre del negocio / de la distribuidora
 *   direccion (string)            con "exacta": calle y numero.
 *                                 con "zona":   SOLO colonia/zona, sin calle ni numero.
 *   ciudad    (string)
 *   estado    (string)            nombre del estado (debe coincidir con el del mapa)
 *   lat, lng  (number)            coordenadas del pin.
 *                                 con "zona": centro aproximado de la colonia, NO su domicilio.
 *   telefono  (string, opcional)  formato visible, ej. "+52 33 1234 5678"
 *   whatsapp  (string, opcional)  solo digitos con lada pais, ej. "523312345678" -> wa.me
 *   maps      (string, opcional)  URL propia de Google Maps; si falta se genera de lat/lng
 *
 * ⚠ PRIVACIDAD — leer antes de cargar una distribuidora real.
 * Las distribuidoras son CLIENTAS, no locales comerciales: muchas venden desde su casa.
 * Publicar calle, numero y coordenadas exactas de un domicilio particular las expone y
 * expone a Jousfit (hay aviso de privacidad publicado). Antes de dar de alta a una real
 * hace falta (1) su consentimiento explicito para aparecer en el mapa publico y (2) que
 * este definido que se publica. Mientras no este definido, usar `precision: "zona"`:
 * con eso la tarjeta muestra colonia/ciudad y el boton lleva a la ZONA, no a su puerta.
 *
 * NOTA: tiendas reales (Ya'axtal, EquilibraT, Rehiletes). Las lat/lng se obtuvieron por
 * geocodificación de las direcciones (Nominatim/OSM) y se validaron por estado (2026-07).
 */
window.JOUSFIT_TIENDAS = [
  {
    id: "yaxtal-altabrisa",
    nombre: "Ya'axtal Altabrisa",
    direccion: "C. 18 #297, Col. Cámara de Comercio Norte, C.P. 97133",
    ciudad: "Mérida",
    estado: "Yucatán",
    lat: 21.015178,
    lng: -89.587188,
    telefono: "9999412603",
  },
  {
    id: "yaxtal-temozon",
    nombre: "Ya'axtal Temozón",
    direccion: "Av. Temozón KM 1.5, Temozón Norte, C.P. 97345",
    ciudad: "Mérida",
    estado: "Yucatán",
    lat: 21.0646,
    lng: -89.59623,
    telefono: "9999412603",
  },
  {
    id: "yaxtal-montejo",
    nombre: "Ya'axtal Montejo",
    direccion:
      "Prol. Paseo de Montejo #109 x 23 y 25 (Local 1), Col. Buenavista, C.P. 97127",
    ciudad: "Mérida",
    estado: "Yucatán",
    lat: 20.990238,
    lng: -89.616802,
    telefono: "999 941 2603",
  },
  {
    id: "equilibrat",
    nombre: "EquilibraT",
    direccion:
      "Diagonal de la 19 poniente 3302 local h colonia el vergel 72400 puebla puebla",
    ciudad: "Puebla",
    estado: "Puebla",
    lat: 19.043616,
    lng: -98.23057,
    telefono: "222 169 8336",
  },
  {
    id: "rehiletes",
    nombre: "Rehiletes",
    direccion:
      "Mercado Sano, Ancha de San Antonio 83-A-Planta Baja, Zona Centro, Centro, 37700 San Miguel de Allende, Gto.",
    ciudad: "San Miguel de Allende",
    estado: "Guanajuato",
    lat: 20.908389,
    lng: -100.747433,
    whatsapp: "524151099492",
  },
  {
    id: "generaciones-en-movimiento",
    nombre: "Generaciones en Movimiento",
    direccion: "José María Morelos #11, Centro",
    ciudad: "Zimapán",
    estado: "Hidalgo",
    lat: 20.737836,
    lng: -99.38364,
  },
];
